import React,{useEffect} from 'react'
import {useLocation } from 'react-router-dom';
import Banner from '../Components/PrePrimaryComponents/Banner/Banner'
import School from '../Components/PrePrimaryComponents/School/School'
import Testimonials from '../Components/PrePrimaryComponents/TestimonialsSchool/TestimonialsSchool'
import Programme from '../Components/PrePrimaryComponents/Programme/Programme'
import Choice from '../Components/PrePrimaryComponents/Choice/Choice'
import Curriculum from '../Components/PrePrimaryComponents/Curriculum/Curriculum'
import Faculties from '../Components/PrePrimaryComponents/Faculties/Faculties'
import AdminssionPre from '../Components/PrePrimaryComponents/AdmissionPre/AdmissionPre'
import Information from '../Components/PrePrimaryComponents/Information/Information'
// import SuccessStory from '../Components/PrePrimaryComponents/SuccessStory/SuccessStory'
import Gallery from '../Components/PrePrimaryComponents/Gallery/Gallery'
import Transportation from '../Components/PrePrimaryComponents/Transportation/Transportation'
import Apply from '../Components/PrePrimaryComponents/Apply/Apply'
import OtherSections from '../Components/PrePrimaryComponents/OtherSections/OtherSections'
import ReactGA from "react-ga4";

ReactGA.initialize("G-KE1087VQ84");

ReactGA.send({ hitType: "pageview", 
                page: window.location.pathname, });
const PrePrimary = () => {
  const ScrollToTop = () => {
    const { pathname, state } = useLocation();
  
    useEffect(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
        if (state && state.targetSection) {
          const targetSection = document.querySelector(state.targetSection);
          if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth' });
          }
        }
      }, 100); // Adding a slight delay to ensure scroll happens after the render
    }, [pathname, state]);
  
    return null;
  };
  return (
    <div>
           <ScrollToTop/>
      <Banner/>
      <School/>
      <Programme/>
      <Choice/>
      <Curriculum/>
      <Faculties/>
      <AdminssionPre/>
      <Information/>
      {/* <SuccessStory/> */}
      <Testimonials/>
      <Gallery/>
      <Transportation/>
      <Apply/>
      <OtherSections/>
      
    </div>
  )
}

export default PrePrimary
